import { Component } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { RasterLayerConfigurationForm, RasterLayerFormComponent } from '../raster-layer-form/raster-layer-form.component';
import { TimeSeriesMetadata } from '@models/mood/metadata';


export interface TimeseriesDatasetConfigurationForm extends RasterLayerConfigurationForm {
}

@Component({
  selector: 'mood-timeseries-dataset-configuration',
  templateUrl: './timeseries-dataset-metadata-form.component.html',
  styleUrls: [
    'timeseries-dataset-metadata-form.component.scss'
  ]
})
export class TimeseriesDatasetConfigurationFormComponent {
  constructor(private _controlContainer: ControlContainer) { }

  get formGroupContainer() {
    return this._controlContainer.control as FormGroup<TimeseriesDatasetConfigurationForm>;
  }

  public static createMetadataFormGroup(existingConfig?: TimeSeriesMetadata) {
    let formGroup = (RasterLayerFormComponent.createMetadataFormGroup(existingConfig) as unknown) as  FormGroup<TimeseriesDatasetConfigurationForm>;

    return formGroup;
  }
}
